export default {"src":"/_next/static/media/instagram_black.0b8a16a5.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};